module.exports = __webpack_public_path__ + "static/media/VectorCityMap.8cc87a78.svg";